import { render } from "./NFTContainer.vue?vue&type=template&id=453a13f4&scoped=true"
import script from "./NFTContainer.vue?vue&type=script&lang=js"
export * from "./NFTContainer.vue?vue&type=script&lang=js"

import "./NFTContainer.vue?vue&type=style&index=0&id=453a13f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453a13f4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
